module.exports = __webpack_public_path__ + "static/media/Order-icon.5f5fb86b.svg";